import { MarkdownSerializer as MarkdownSerializerBase } from 'prosemirror-markdown';

import {
  mention,
  blockquote,
  code_block,
  bullet_list,
  ordered_list,
  list_item,
  paragraph,
  image,
  hard_break,
  text,
  html_block,
  em,
  strike,
  strong,
  link,
  code,
  fontSize,
  fontFamily,
  textColor,
} from './serializer';

export const MessageMarkdownSerializer = new MarkdownSerializerBase(
  {
    mention,
    blockquote,
    code_block,
    bullet_list,
    ordered_list,
    list_item,
    paragraph,
    image,
    hard_break,
    text,
    html_block,
  },
  {
    em,
    strike,
    strong,
    link,
    code,
    fontSize,
    fontFamily,
    textColor,
  }
);
